import React from 'react';
import styled from 'App/styled';
import { isIndiaSelected } from 'shared/helpers/utils/internationalShipping';
import { INTERNATIONAL_FREE_SHIPPING } from 'shared/constants/internationalShipping';

const FeaturesWrap = styled.div`
  background-color: ${(props) => props.theme.featuresBak};
  color: ${(props) => props.theme.featuresColor};
  margin-top: 9px;
  padding-top: 20px;
  padding-bottom: 20px;
  ${({ theme }) => theme.typography.bodySmall};

  display: flex;
  justify-content: center;

  div:last-child {
    padding-right: 0;
  }
  div:first-child {
    padding-left: 0;
  }
`;

const FeaturesItem = styled.div`
  padding: 0 25px;
  display: flex;
  line-height: 20px;
  flex: 1;
  img {
    margin-bottom: auto;
  }
`;

const TaglineTitle = styled.div`
  ${({ theme }) => theme.typography.subTitleMedium};
  text-transform: uppercase;
  margin: 0 15px 10px 15px;
  text-align: left;
  padding-bottom: 5px;
  border-bottom: 1px solid #e1e1e1;
`;

const TaglineText = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  padding: 0 15px;
`;

interface FeaturesProps {
  internationalMode: boolean;
  freeShipping: number;
  featuresEnabled: boolean;
  features: {
    brandsCount: { [key: string]: string };
    freeShip: {
      iconUrl: string;
      title: string;
      text: string;
      textSuffix?: string;
    };
    genuineProduct: { [key: string]: string };
    easyReturns: { [key: string]: string };
  };
}

const Features = ({
  internationalMode,
  featuresEnabled,
  features,
  freeShipping,
}: FeaturesProps) => {
  const { brandsCount, freeShip, genuineProduct, easyReturns } = features || {};
  const {
    iconUrl: freeShipIcon,
    title: freeShipTitle,
    text: freeShipText,
    textSuffix: freeShipTextSuffix,
  } = freeShip || {};
  const orderValue =
    internationalMode && !isIndiaSelected()
      ? INTERNATIONAL_FREE_SHIPPING
      : freeShipping;
  if (!featuresEnabled) return null;

  return (
    <>
      <FeaturesWrap>
        {freeShip && Object.keys(freeShip).length && (
          <FeaturesItem>
            <img
              src={freeShipIcon}
              alt=""
            />
            <div>
              <TaglineTitle>{freeShipTitle}</TaglineTitle>
              <TaglineText>
                {freeShipText}
                {orderValue}
                {freeShipTextSuffix && freeShipTextSuffix}
              </TaglineText>
            </div>
          </FeaturesItem>
        )}
        {easyReturns && Object.keys(easyReturns).length && (
          <FeaturesItem>
            <img
              src={easyReturns?.iconUrl}
              alt=""
            />
            <div>
              <TaglineTitle>{easyReturns?.title}</TaglineTitle>
              <TaglineText>{easyReturns?.text}</TaglineText>
            </div>
          </FeaturesItem>
        )}
        {genuineProduct && Object.keys(genuineProduct).length && (
          <FeaturesItem>
            <img
              src={genuineProduct?.iconUrl}
              alt=""
            />
            <div>
              <TaglineTitle>{genuineProduct?.title}</TaglineTitle>
              <TaglineText>{genuineProduct?.text}</TaglineText>
            </div>
          </FeaturesItem>
        )}
        {brandsCount && Object.keys(brandsCount).length && (
          <FeaturesItem>
            <img
              src={brandsCount?.iconUrl}
              alt=""
            />
            <div>
              <TaglineTitle>{brandsCount?.title}</TaglineTitle>
              <TaglineText>{brandsCount?.text}</TaglineText>
            </div>
          </FeaturesItem>
        )}
      </FeaturesWrap>
    </>
  );
};

export default Features;
